<template>
    <footer :class="['order-footer', `order-footer--${orderStep}`, {'order-footer--fullscreen': fullscreen, 'order-footer--is-mobile': isMobile, 'order-footer--has-feed': isMobile && ['3-digital-more-photos', '3-default-more-photos'].includes(orderStep)}]">
        <div>
            <button v-if="!uuid" class="btn btn-icon-left btn-light text-uppercase order-footer-back-btn" :class="{'btn-large-shadow': fullscreen}" @click.prevent="back">
                <span class="material-icon icon-keyboard_arrow_left"></span>
                <template v-if="!isMobile">{{ $t('back') }}</template>
            </button>
            <ul v-if="isMobile" class="mobile-menu__actions">
                <li class="mobile-menu__action">
                    <a href="#" @click.prevent="$emit('close-order')" class="action-link">
                        <span class="material-icon icon-clear"></span>
                        <span class="action-link__txt">{{ $t('cancel') }}</span>
                    </a>
                </li>
            </ul>
        </div>
        <div v-if="!carouselView && [4, '3-digital-more-photos', '3-default-more-photos'].includes(orderStep)">
            <button v-if="orderStep === 4" id="chooseMorePhotosBtn" class="btn btn-icon-left btn-light" :class="{'-mobile-choose-more-photos-btn': isMobile}" @click.prevent="back">
                <span class="material-icon icon-add" :style="{visibility: isMobile ? 'hidden': 'visible'}"/>
                {{ $t('choose_more_photos') }}
            </button>
            <template v-if="!isMobile && ['3-digital-more-photos', '3-default-more-photos'].includes(orderStep)">
                <button @click="selectAll" class="btn btn-icon-left btn-light text-uppercase mr-3" :class="{'btn-large-shadow': fullscreen}">
                    <svg class="svg-icon" width="18px" height="19px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <path d="M16,0 L2,0 C0.89,0 0,0.9 0,2 L0,16 C0,17.1 0.89,18 2,18 L16,18 C17.1,18 18,17.1 18,16 L18,2 C18,0.9 17.1,0 16,0 Z M16,16 L2,16 L2,2 L16,2 L16,16 Z M8,14 L10,14 L10,10 L14,10 L14,8 L10,8 L10,4 L8,4 L8,8 L4,8 L4,10 L8,10 L8,14 Z"></path>
                    </svg>
                    {{ $t('select_all') }}
                </button>
                <button @click="deselectAll" class="btn btn-icon-left btn-light text-uppercase" :class="{'btn-large-shadow': fullscreen}">
                    <svg class="svg-icon" width="18px" height="19px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <path d="M16,0 L2,0 C0.9,0 0,0.9 0,2 L0,16 C0,17.1 0.9,18 2,18 L16,18 C17.1,18 18,17.1 18,16 L18,2 C18,0.9 17.1,0 16,0 Z M16,16 L2,16 L2,2 L16,2 L16,16 Z M4,8 L14,8 L14,10 L4,10 L4,8 Z"></path>
                    </svg>
                    {{ $t('deselect_all') }}
                </button>
            </template>
        </div>
        <div>
            <div v-if="orderStep === 1 && showNextButton" :class="['order-footer--favorite', { disabled: isDisabled }]">
                <button @click.prevent="handleFavorite"
                        id="addToFavoritesBtn"
                        :class="['btn', 'btn-icon-left', 'text-uppercase', 'mr-3', 'btn-light']">
                    <span class="material-icon" :class="isFavorite ? 'icon-indeterminate_check_box' : 'icon-library_add'"></span>
                    {{ !isFavorite ? $t('add_to_selected') : $t('delete_from_selected') }}
                </button>
            </div>
            <button v-if="showNextButton"
                    @mouseenter="showLimitNotification()"
                    id="nextStepBtn"
                    :class="[
                        'btn', `${fullscreen ? 'btn-large-shadow' : 'btn-shadow'}`,
                        {'btn-icon-left': !isMobile},
                        disabledNextButton ? 'btn-light btn-disabled btn-disabled--default-pointer-events' : 'btn-success',
                        'text-uppercase']"
                    @click.prevent="next">
                <template v-if="isMobile">
                    <template v-if="orderStep === 4">
                        <span class="material-icon icon-add_shopping_cart"/>
                    </template>
                    <template v-else>
                        <span class="material-icon icon-check"/>
                    </template>
                </template>
                <template v-else>
                    <template v-if="orderStep === 1">
                        <span class="material-icon icon-add"></span>
                        {{ $t('order_photo') }}
                    </template>
                    <template v-if="['3-digital-confirm', '3-default-confirm'].includes(orderStep)">
                        <span class="material-icon icon-add"></span>
                        {{ $t('select_product') }}
                    </template>
                    <template v-if="['3-digital-bulk-prices', '3-default-bulk-prices'].includes(orderStep)">
                        {{ $t('skip_and_next') }}
                        <span class="material-icon icon-keyboard_arrow_right"/>
                    </template>
                    <template v-if="['3-digital-more-photos', '3-default-more-photos'].includes(orderStep)">
                        <template v-if="balance > 0">
                            {{ $tc('next_still_n_photos', balance, {balance}) }}
                        </template>
                        <template v-else>{{ $t('next') }}</template>
                    </template>
                    <template v-if="orderStep === 4">
                        <span class="material-icon icon-add_shopping_cart"/>
                        <template v-if="uuid">
                            {{ $t('confirm') }}
                        </template>
                        <template v-else>
                            {{ $t('add_to_cart') }}
                        </template>
                    </template>
                </template>
            </button>
        </div>
    </footer>
</template>

<style>
    .-mobile-choose-more-photos-btn {
        position: absolute;
        width: 0;
        padding: 0;
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
        overflow: hidden;
    }
</style>

<script>
  import orderFooter from 'src/mixins/orderFooterComponent';

  export default {
    mixins: [orderFooter],
  };
</script>
